import LingkAdapterReaderNode from './types/lingk-adapter-reader';
import LingkAdapterWriterNode from './types/lingk-adapter-writer';
import LingkWriterNode from './types/lingk-writer';

export const lingkNodes = {
  lingkWriter: LingkWriterNode,
  lingkAdapterReader: LingkAdapterReaderNode,
  lingkAdapterWriter: LingkAdapterWriterNode,
};
